<template>
  <div class="tian-di-tu">
    <img src="@/assets/images/tdt-bg.png" alt="" />
    <span>{{ textVal }}</span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      img: tdtConfig.imgSrc,
      textVal: tdtConfig.textVal,
    };
  },
};
</script>
<style scoped>
.tian-di-tu {
  position: absolute;
  left: 1%;
  bottom: 10px;
  width: 120px;
  height: 60px;
  z-index: 1;
}
.tian-di-tu img {
  width: 120px;
}
.tian-di-tu span {
  color: #fff;
  font-size: 11px;
  background: #78787873;
  padding: 5px 0;
  display: inline-block;
  text-align: center;
  width: 100%;
}
</style>